<template>
  <div class="ship-popup">
    <div class="cesium-popup-header flex justify-between align-center">
      <span>基站信息</span>
      <ElButton circle size="small" @click="props.close">X</ElButton>
    </div>
    <table v-if="properties">
      <tbody>
        <tr v-for="item in tableData" :key="item.key">
          <td class="text-green-800">{{ item.key }}</td>
          <td :style="item.color ? { color: item.color } : {}" >{{ item.value }}</td>
        </tr>
        <!---死图-->
        <tr>
          <td class="text-green-800">图片：</td>
          <td><img style="width: 200px; height: 200px;" src="@/assets/ais_sample.png" alt="" srcset=""></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { ElButton } from 'element-plus'

const props = defineProps<{
  properties: {
    type: string
    status: 'normal' | 'fault'
    name: string
    location?: string
  }
  close(): void
}>()
const properties = computed(() => {
  return props.properties
})
const tableData = computed(() => {
  return [
      {
        key: '名称：',
        value: props.properties.name,
      },
      {
        key: '类型：',
        value:  'AIS/VHF/摄像头',
      },
      {
        key: '位置：',
        value: props.properties.location || '未知位置',
      },
      {
        key: '状态：',
        value: props.properties.status === 'normal' ? '正常' : '故障',
        color: props.properties.status === 'normal' ? '#52c41a' : '#ff4d4f'
      }
    ]
})
</script>
<style scoped>
.ship-popup {
  z-index: 998; /* 设置层级 */
}
</style>
